/**
 * Created by hp on 2017/6/13.
 */
import React, {Component} from 'react';
import {connect} from 'react-redux';
import LectureDialog from './LectureDialog';

class LectureRelayDialog extends Component {
    constructor() {
        super();
        this.onRequestClose = this.onRequestClose.bind(this);
    }

    onRequestClose() {
        this.props.dispatch({
           type: 'LECTURE_HIDE_RELAY_DIALOG'
        });
    }

    render() {
        let title = "<p style='color:#3cc51f;font-size:1.1rem;'>恭喜你，成功转载</p>" +
                    "<p style='color:#3cc51f;font-size:1.1rem;'>是大公司的</p>";
        const {showRelayDialog} = this.props;
        return (
            <div>
                <LectureDialog
                    title={title}
                    closeText="邀请好友来听课"
                    show={showRelayDialog}
                    onRequestClose={this.onRequestClose}>
                    <div className="text-minor">
                        <p>温馨提示</p>
                        <p>1. 转载课程与主课程内容实时同步；</p>
                        <p>2. 所有评论都会在主课程里面显示哦；</p>
                        <p>3.转载间属于您独有的店铺；</p>
                        <p>4. 可邀请好友进入听课；</p>
                        <p>5. 最终解释权归所有</p>
                    </div>
                </LectureDialog>
            </div>
        )
    }
}

export default connect((state) => ({
    showRelayDialog: state.lecture.showRelayDialog
}))(LectureRelayDialog);



// WEBPACK FOOTER //
// ./src/components/lecture/LectureRelayDialog.js